import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const RegimeQuickViewState = mediatorAtom<{
    isOpen: boolean;
}>({ isOpen: false });

export default function useRegimeQuickView() {
    return useMediatorState(RegimeQuickViewState);
}
